import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'


Vue.use(Vuetify, {
  iconfont: 'md',
  theme: 
  {
     primary: '#4da947',
     secondary: '#34588e',
     accent: '#03a9f4',
     error: '#f44336',
     warning: '#ff5722',
     info: '#607d8b',
     success: '#8bc34a'
     }
})
